exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/page-header/page-header.component.scss
// module id = ../../../../../src/app/shared/modules/page-header/page-header.component.scss
// module chunks = main